import React, { useState, useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom'
import { Form, FormGroup, Label, Input, Row, Col, Card, CardBody, Container } from 'reactstrap';
import { useDropzone } from 'react-dropzone';
import { formatBytes } from '../../Common';
import { getSingleBanner, updateBanners } from '../../API/Backend';
import { showToast } from "../../Components/Toast"

const EditBanner = () => {
  const params = useParams();
  const id = params.id;
  const history = useNavigate();
  const [bannerName, setBannerName] = useState('Market Banner');
  const [bannerFile, setBannerFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState('https://images.unsplash.com/photo-1506744038136-46273834b3fb');
  const [errors, setErrors] = useState({ bannerName: "", bannerFile: "", previewUrl: "" });
  const [loading, setLoading] = useState(false);
  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
  const ALLOWED_FORMATS = ['jpg', 'jpeg', 'png'];

  useEffect(() => {
    fetchSingleBanners();
  }, []);

  const fetchSingleBanners = () => {
    setLoading(true)
    getSingleBanner(id).then(({ data }) => {
      if (data.data) {
        setBannerName(data.data.title)
        setPreviewUrl(`${process.env.REACT_APP_IMAGE_DIRECTORY}/${data.data.image}`)
      }
      else {
        showToast("error", "Request Failed", data.message)
      }
      setLoading(false)
    }).catch((err) => {
      showToast("error", "Request Failed", err.message)
      setLoading(false)
    })
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setBannerFile(file);
    setPreviewUrl(URL.createObjectURL(file)); // update preview
  };

  const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];

    setErrors({ bannerFile: "", previewUrl: "" });

    if (!file) {
      setErrors({ bannerFile: "No file selected." });
      setBannerFile(null);
      setPreviewUrl(null);
      return;
    }

    const fileExt = file.name.split('.').pop().toLowerCase();
    if (!ALLOWED_FORMATS.includes(fileExt)) {
      setErrors({ bannerFile: "Only jpg, jpeg, png files are allowed." });
      setBannerFile(null);
      setPreviewUrl(null);
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      setErrors({ bannerFile: "File size should be less than 5MB." });
      setBannerFile(null);
      setPreviewUrl(null);
      return;
    }

    const formattedFiles = [file].map(f =>
      Object.assign(f, {
        formattedSize: formatBytes(f.size),
        preview: URL.createObjectURL(f),
      })
    );

    setBannerFile(formattedFiles[0]);
    setPreviewUrl(formattedFiles[0].preview);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    // accept: {
    //   'image/jpeg': ['.jpeg', '.jpg'],
    //   'image/png': ['.png']
    // },
    multiple: false
  });

  const handleSubmit = (e) => {
    e.preventDefault()
    let flag = false;
    let error = { bannerName: "", bannerFile: "", previewUrl: "" };
    if (!bannerName || bannerName.replace(/\s/g, '').length < 1) {
      flag = true;
      error.bannerName = "Please provide a valid name";
    }
    setErrors(error)
    if (!flag) {
      setLoading(true);
      const formData = new FormData();
      formData.append("title", bannerName);
      if(bannerFile){
        formData.append("image", bannerFile);
      }
      updateBanners(formData, id).then((data) => {
        if (data.data.success) {
          showToast("success", "Banner Updated", "Banner has been updated successfully.")
          setLoading(false);
          history('/banners')
        }
        else {
          showToast("error", "Banner Request Failed", "Banner could not be updated.")
          setLoading(false);
        }
      }).catch((e) => {
        showToast("error", "Banner Request Failed", "Banner could not be updated.")
        setLoading(false);
      })
    }
  };

  return (
    <Container fluid>
      <Row>
        <Col>
          <h4 className="fw-600 fs-18 mb-4">Edit Banner</h4>
          <Card className='pt-2'>
            <CardBody>
              <Form onSubmit={handleSubmit}>
                <FormGroup>
                  <Input
                    type="text"
                    id="bannerName"
                    value={bannerName}
                    onChange={(e) => setBannerName(e.target.value)}
                  />
                </FormGroup>
                {/* <FormGroup className="text-center my-4 border p-4 rounded" style={{ borderStyle: 'solid', borderColor: '#c0eac0' }}>
                  <Label for="bannerFile" className="w-100" style={{ cursor: 'pointer' }}>
                    <img
                      src={previewUrl}
                      alt="Banner Preview"
                      style={{ width: '100%', maxHeight: '200px', objectFit: 'cover' }}
                    />
                    <div className="text-end mt-1" style={{ fontSize: '0.85rem', color: '#6c757d' }}>
                      <i className="fa fa-pencil" /> Edit
                    </div>
                  </Label>
                  <Input
                    type="file"
                    id="bannerFile"
                    onChange={handleFileChange}
                    hidden
                  />
                </FormGroup> */}
                <FormGroup>
                  <div
                    {...getRootProps()}
                    className="text-center my-4 border p-4 rounded"
                    style={{
                      borderStyle: 'dashed',
                      cursor: 'pointer',
                      backgroundColor: '#f9f9f9'
                    }}
                  >
                    <input {...getInputProps()} />
                    {previewUrl ? (
                      <img
                        src={previewUrl}
                        alt="Preview"
                        style={{
                          width: '100%',
                          maxHeight: '200px',
                          objectFit: 'cover',
                          borderRadius: '6px',
                        }}
                      />
                    ) : (
                      <div>
                        <img src={previewUrl} alt="Upload Icon" />
                        <p className="fs-14 fw-400">
                          {isDragActive ? 'Drop the image here...' : 'Upload Banner'}
                        </p>
                      </div>
                    )}
                  </div>
                  {errors.bannerFile && <div className="text-danger fs-12">{errors.bannerFile}</div>}
                </FormGroup>

                <FormGroup className='text-end'>
                  <button disabled={loading} className='btn btn-primary' type="submit">{loading ? 'Please Wait' : 'Update'}</button>
                </FormGroup>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}
export default EditBanner